<template>
  <div class="order-confrim">
    <close @close="goabck" title="订单确认"></close>

    <!-- 商品列表 -->
    <div class="order-confrim-wrapper" v-show="confirmOrderList.length">
      <div
        :key="index"
        class="order-platform"
        v-for="(platfrom, index) in confirmOrderList"
      >
        <div class="order-platform-wrapper">
          <div class="platform-title van-hairline--bottom">
            以下商品由
            <em>{{ platfrom.platform_info.brand }}</em> 提供供应链支持
          </div>
          <div class="platform-sku-list">
            <a
              @click="showPlatformGoods(platfrom.sku_list)"
              class="jump-details"
              href="javascript:;"
            >
              <div class="sku-imgs">
                <div class="sku-imgs-wrapper auto-x">
                  <div
                    :key="index"
                    class="sku-img"
                    v-for="(sku, index) in platfrom.sku_list"
                  >
                    <img class="van-hairline--surround" v-lazy="sku.sku_img" />
                    <span class="problem-mask" v-show="sku.problem">
                      {{ sku.problem }}</span
                    >
                  </div>
                </div>
              </div>
              <span class="tips">
                共{{ platfrom.sku_list | totalize }}件
                <img src="../assets/img/public/double-arrow.png" />
              </span>
            </a>
          </div>
          <div
            class="fill-address van-hairline--bottom"
            v-if="!platfrom.receiver && platfrom.need_address"
          >
            <button @click="fillAddressHandler(platfrom.platform_info)">
              请完善收货地址
            </button>
          </div>
          <div
            class="platform-address"
            v-else-if="platfrom.receiver && platfrom.need_address"
          >
            <order-address
              :address="platfrom.receiver"
              :platform="platfrom.platform_info"
              :showEdit="true"
              @edit="fillAddressHandler(platfrom.platform_info)"
            ></order-address>
          </div>
          <div class="platform-freight" v-show="platfrom.count_exp_fee">
            本单需运费：
            <em>+ ¥{{ platfrom.count_exp_fee }}</em>
          </div>
        </div>
      </div>
    </div>

    <template v-if="confirmOrderList.length">
      <!-- 优惠券使用购物金抵扣 -->
      <div class="discount-choose">
        <div class="shopping-gold-wrapper">
          <div class="user-shopping-gold">
            <span class="hint" v-if="includesGoldGoodsStatus">使用福利金</span>
            <template v-else>
              <span class="hint">福利金不可用</span>
              <p class="sub-hint">
                结算商品中没有符合条件的商品
                <!-- 结算商品中有不符合条件的商品 -->
              </p>
            </template>
            <span>福利金余额：{{ goldNum }}</span>
          </div>
          <div class="shopping-gold-check-status">
            <van-switch
              :disabled="goldCheckDisabled"
              :value="goldCheckStatus"
              @input="onGoldSwitchInput"
              class="gold-switch"
              inactive-color="#ccc"
              size="15px"
            ></van-switch>
            <span v-show="goldCheckStatus">
              抵扣：
              <em class="normal-price-c">¥{{ goldDiscountNum }}</em>
            </span>
          </div>
        </div>
      </div>

      <!-- 优惠券使用爱心币抵扣 -->
      <div class="discount-choose">
        <div class="shopping-gold-wrapper">
          <div class="user-shopping-gold">
            <span class="hint" v-if="includesLoveGoodsStatus">使用爱心币</span>
            <template v-else>
              <span class="hint">爱心币不可用</span>
              <p class="sub-hint">
                结算商品中没有符合条件的商品
                <!-- 结算商品中有不符合条件的商品 -->
              </p>
            </template>
            <span>爱心币余额：{{ loveNum }}</span>
          </div>
          <div class="shopping-gold-check-status">
            <van-switch
              :disabled="loveCheckDisabled"
              :value="loveCheckStatus"
              @input="onLoveSwitchInput"
              class="gold-switch"
              inactive-color="#ccc"
              size="15px"
            ></van-switch>
            <span v-show="loveCheckStatus">
              抵扣：
              <em class="normal-price-c">¥{{ loveDiscountNum }}</em>
            </span>
          </div>
        </div>
      </div>

      <!-- 使用体验金抵扣 -->
      <div class="discount-choose">
        <div class="shopping-gold-wrapper">
          <div class="user-shopping-gold">
            <span class="hint" v-if="includesEGStatus">使用体验金</span>
            <template v-else>
              <span class="hint">体验金不可用</span>
              <p class="sub-hint">
                结算商品中没有符合条件的商品
                <!-- 结算商品中有不符合条件的商品 -->
              </p>
            </template>
            <span>体验金余额：{{ EGNum }}</span>
          </div>
          <div class="shopping-gold-check-status">
            <van-switch
              :disabled="EGCheckDisabled"
              :value="EGCheckStatus"
              @input="onEGSwitchInput"
              class="gold-switch"
              inactive-color="#ccc"
              size="15px"
            ></van-switch>
            <span v-show="EGCheckStatus">
              抵扣：
              <em class="normal-price-c">¥{{ EGDiscountNum }}</em>
            </span>
          </div>
        </div>
      </div>

      <!-- 订单简介 -->
      <div class="order-intro">
        <div class="order-price van-hairline--bottom">
          <span class="title">实付金额</span>
          <span class="price">¥{{ payPrice }}</span>
        </div>
        <div class="order-options">
          <div class="option">
            <span class="title">商品金额</span>
            <span>¥{{ totalPrice }}</span>
          </div>
          <div class="freight option">
            <div class="freight-tips title">
              <span>预估运费</span>
              <button @click="showFreightTips" class="tips"></button>
            </div>
            <span>+ ¥{{ totalFreight }}</span>
          </div>
          <div
            class="option shopping-gold-discount"
            :class="discount.title==='爱心币抵扣'|| discount.title==='福利金抵扣'?'arrow-right':''"
            v-for="(discount, index) in orderDiscountList"
            :key="index"
            @click="showPlatformGoods(confirmOrderList, discount.title==='爱心币抵扣'?2:(discount.title==='福利金抵扣'?1:3))"
          >
            <span class="title">{{ discount.title }}</span>
            <span>- ¥{{ discount.discount }}</span>
          </div>
        </div>
      </div>
    </template>

    <!-- 底部导航 -->
    <div class="shoping-trolley-footer van-hairline--top">
      <div class="product-total-price">
        <div class="total-price">
          <div class="total">
            <span>实付:</span>
            <div class="price">
              ¥
              <em>{{ payPrice }}</em>
            </div>
          </div>
          <div class="shop-wealfare" v-show="totalRebate * 1 > 0">
            返 {{ totalRebate }} 福利金
          </div>
        </div>
        <div class="settle-accounts">
          <button
            :class="{ 'cannot-submit': canSubmit }"
            @click="settleAccounts"
            class="submit"
          >
            去结算
          </button>
        </div>
      </div>
    </div>

    <!-- 开通会员提示 -->
    <div class="dredge-tips" v-if="userInfo && userInfo.top_member">
      <open-member-tips :discounts="memberDiscount" />
    </div>

    <user-dialog
      :show="dialog.show"
      @cancel-handler="cancelHandler"
      @confrim-handler="confrimHandler"
    >
      <template #msg>{{ dialog.text }}</template>
    </user-dialog>

    <user-dialog
      :show="freightTips.show"
      :show-cancel="freightTips.showCancel"
      :show-msg="freightTips.showMsg"
      @confrim-handler="closeFreightTips"
    >
      <template #default>
        <div class="freight-tips-desc">
          <h2>为什么是预估运费？</h2>
          <p>
            很抱歉，由于购物信息的信息不充分，我们无法在这一步给出精确的运费价格，请您以最终结算的运费为准。
          </p>
        </div>
      </template>
    </user-dialog>

    <popup
      position="bottom"
      v-model="showGoodsStatus"
      closeable
      :style="{ height: '70%' }"
    >
      <div class="platform-goods">
        <div class="title">商品清单</div>

        <div class="goods-list">
          <div
            class="goods-item van-hairline--bottom"
            v-for="(goods, index) in goodsList"
            :key="index"
          >
            <div class="goods-details">
              <div class="goods-img van-hairline--surround">
                <img v-lazy="goods.sku_img" />
                <span class="problem-mask" v-show="goods.problemHint">{{
                  goods.problemHint
                }}</span>
              </div>
              <div class="goods-intro">
                <div class="name van-multi-ellipsis--l2">
                  {{ goods.sku_name }}
                </div>
                <div class="sku-hint" v-if="goods.is_type">
                  <i class="gold_type red" v-if="Number(goods.is_type) === 1">可用福利金</i>
                  <i class="gold_type" v-else-if="Number(goods.is_type) === 2">可用爱心币</i>
                  <i class="gold_type" v-else-if="Number(goods.is_type) === 4">可用体验金</i>
                </div>
                <div class="sub-name">
                  <span
                    class="van-ellipsis"
                    v-show="
                      goods.attr_list &&
                        JSON.stringify(goods.attr_list) !== '{}'
                    "
                  >
                    <em :key="index" v-for="(item, index) in goods.attr_list">{{
                      item.attr_value.value
                    }}</em>
                  </span>
                </div>
                <div class="goods-price-num">
                  <div class="price">
                    ¥
                    <em>{{ goods.market_price }}</em>
                  </div>
                  <div class="num">数量: {{ goods.sku_num }}</div>
                </div>
                <div class="goods-tips" v-show="goods.rebate * 1">
                  返{{ goods.rebate }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </popup>
  </div>
</template>

<script>
import { Switch, Popup } from 'vant'
import Close from '../components/Close'
import OpenMemberTips from '../components/OpenMemberTips'
import OrderAddress from '../components/OrderAddressChange'
import UserDialog from '../components/Dialog'
import { mapState } from 'vuex'
let flag = false
export default {
  props: {
    oid: {
      type: String
    },
    type: {
      type: String,
      default: 'cart'
    }
  },
  components: {
    'VanSwitch': Switch,
    Close,
    OrderAddress,
    UserDialog,
    Popup,
    OpenMemberTips
  },
  data () {
    return {
      confirmOrderList: [],
      goldNum: 0,
      loveNum: 0,
      EGNum: 0,
      totalRebate: 0,
      totalPrice: 0,
      totalFreight: 0,
      payPrice: 0,
      goldDiscountNum: 0,
      loveDiscountNum: 0,
      EGDiscountNum: 0,
      goldCheckStatus: false,
      loveCheckStatus: false,
      EGCheckStatus: false,
      orderDiscountList: [],
      memberTotalPrice: 0,
      memberRebatePrice: 0,
      memberDiscount: 0,
      dialog: {
        show: false,
        text: '选了这么久, 确认要退出么?'
      },
      freightTips: {
        show: false,
        showCancel: false,
        showMsg: false
      },
      showGoodsStatus: false,
      goodsList: [],
      canUseGoldStatus: false
    }
  },
  computed: {

    ...mapState('store', ['userInfo']),
    includesGoldGoodsStatus () {
      return this.confirmOrderList.some(platform => platform.sku_list.some(v => Number(v.is_type) === 1))
    },
    includesLoveGoodsStatus () {
      return this.confirmOrderList.some(platform => platform.sku_list.some(v => Number(v.is_type) === 2))
    },
    includesEGStatus () {
      return this.confirmOrderList.some(platform => platform.sku_list.some(v => Number(v.is_type) === 4))
    },
    goldCheckDisabled () {
      return !(this.goldNum && this.goldNum * 1 > 0) || !this.includesGoldGoodsStatus
    },

    loveCheckDisabled () {
      return !(this.loveNum && this.loveNum * 1 > 0) || !this.includesLoveGoodsStatus
    },

    EGCheckDisabled () {
      return !(this.EGNum && this.EGNum * 1 > 0) || !this.includesEGStatus
    },

    // 是否可提交状态
    canSubmit () {
      return this.confirmOrderList.some(v => v.need_address && !v.receiver)
    },

    goldCheckStatusText () {
      return this.goldNum * 1 > 0 ? this.goldCheckStatus ? '全部使用' : '不使用' : '暂无可用'
    }

  },

  filters: {
    totalize (sku) {
      return sku.reduce((total, v) => total + (v.sku_num * 1), 0)
    }
  },

  watch: {
    goldCheckDisabled (newVal) {
      if (newVal) {
        this.goldCheckStatus = false
      }
    },
    loveCheckDisabled (newVal) {
      if (newVal) {
        this.loveCheckStatus = false
      }
    },
    EGCheckDisabled (newVal) {
      if (newVal) {
        this.EGCheckStatus = false
      }
    }
  },

  created () {
    this.$toast.loading('正在加载,请稍候...')
  },

  mounted () {
    this.getTempOrderHandler()
  },

  methods: {

    // 平台订列表详情
    showPlatformGoods (goodsList, isType) {
      if (isType) {
        if (isType === 3) {
          return false
        }
        this.goodsList = []
        this.confirmOrderList.forEach(platform => {
          platform.sku_list.forEach(v => {
            if (Number(v.is_type) === isType) {
              this.goodsList.push(v)
            }
          })
        })
      } else {
        this.goodsList = goodsList
      }
      this.showGoodsStatus = true
    },

    onGoldSwitchInput () {
      this.updateTempOrderHandler({ sa: !this.goldCheckStatus, sb: this.loveCheckStatus, se: this.EGCheckStatus })
    },
    onLoveSwitchInput () {
      this.updateTempOrderHandler({ sa: this.goldCheckStatus, sb: !this.loveCheckStatus, se: this.EGCheckStatus })
    },
    onEGSwitchInput () {
      this.updateTempOrderHandler({ sa: this.goldCheckStatus, sb: this.loveCheckStatus, se: !this.EGCheckStatus })
    },
    // 返回上一级
    goabck () {
      this.dialog.show = true
    },

    // 弹窗 取消
    cancelHandler () {
      this.dialog.show = false
    },

    // 弹窗确认
    confrimHandler () {
      this.$router.back()
      this.dialog.show = false
    },

    showFreightTips () {
      this.freightTips.show = true
    },

    // 预估运费提示
    closeFreightTips () {
      this.freightTips.show = false
    },

    // 填写地址
    async fillAddressHandler (platform) {
      this.$router.push({
        name: 'userAddressManager',
        query: {
          platformName: platform.name,
          platformType: platform.addr_data,
          platformBrand: platform.brand,
          oid: this.oid,
          type: this.type,
          sa: this.goldCheckStatus + '',
          sb: this.loveCheckStatus + '',
          se: this.EGCheckStatus + ''
        }
      })
    },

    // 去结算 下单
    async settleAccounts () {
      if (this.canSubmit) {
        this.$toast('请完善收货地址')
        return false
      }
      if (flag) {
        return
      }
      flag = true
      await this.submitTempOrderHandler()
      flag = false
    },

    /**
     * 提交临时订单
     */
    async submitTempOrderHandler () {
      this.$toast.loading('正在提交订单,请稍候...')
      const res = await this.$axios.post('api/order/2.0/cto', {
        type: this.type,
        data: {
          id: this.oid
        }
      })
      if (res.status === 200) {
        const { code, data, msg } = res.data
        if (code === 0) {
          this.pay(data.trade_id)
        } else if (code === 100) {
          this.$toast('下单成功')
          setTimeout(() => {
            this.$router.replace({ name: 'orderDetails', query: { orderid: data.trade_id } })
          }, 500)
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 支付
     * @param { String } id 订单id
     */
    async pay (id) {
      this.$toast.loading('下单成功,正在为您拉起支付')
      const res = await this.$axios.post('api/pay/order', { id })
      if (res.status === 200) {
        const { code, data, msg } = res.data
        this.$toast.clear()
        if (code === 0) {
          location.replace(data.redirect)
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 更新临时订单
     * @param { Boolean } sa 购物金选中状态
     * @param { type } type 临时订单类型 默认cart 购物车创建临时订单
     * @param { String } id 订单ID
     * @param { Object } params sa 购物金选中状态  address 地址信息 {id: 地址id, platform: 商品平台信息, addr_data: 地址归属 }
     * @returns { Boolean } true/false
     */
    async updateTempOrderHandler (params) {
      this.$toast.loading('请稍候...')
      const res = await this.$axios.post('api/order/2.0/uto', {
        type: this.type,
        data: {
          id: this.oid,
          ...params
        }
      })
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg } = res.data
        if (code === 0) {
          this.getTempOrderHandler()
          return true
        } else {
          this.$toast(msg)
          return false
        }
      }
    },

    /**
     * 获取临时订单信息
     */
    async getTempOrderHandler () {
      const res = await this.$axios.post('api/order/2.0/gto', {
        type: this.type,
        data: { id: this.oid }
      })
      if (res.status === 200) {
        this.$toast.clear()
        const { code, data, msg } = res.data
        if (code === 0) {
          this.goldNum = data.account
          this.loveNum = data.account_love
          this.EGNum = data.account_experience
          const orderInfo = data.order.goods
          this.totalRebate = orderInfo.count_rebate
          this.totalPrice = orderInfo.count_price
          this.totalFreight = orderInfo.count_exp_fee
          this.payPrice = orderInfo.count_real_pay
          this.memberDiscount = orderInfo.suggest_discount
          this.goldCheckStatus = data.order.sa
          this.loveCheckStatus = data.order.sb
          this.EGCheckStatus = data.order.se
          this.goldDiscountNum = orderInfo.sa_discount
          this.loveDiscountNum = orderInfo.sb_discount
          this.EGDiscountNum = orderInfo.se_discount
          this.orderDiscountList = orderInfo.discount_list
          this.confirmOrderList = orderInfo.platform
          // this.canUseGoldStatus = data.user_flj
        } else if (code === 9006) {
          this.$router.replace({ name: 'home' })
        } else {
          this.$toast(msg)
        }
      }
    }
  }

}
</script>

<style lang="less" scoped>
@keyframes mymove {
  0% {
    transform: scale(1); /*开始为原始大小*/
  }
  25% {
    transform: scale(0.9); /*放大1.1倍*/
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}
.order-confrim {
  padding: 0 0 1.5rem;
  .order-confrim-wrapper {
    padding: 0 0 0.2rem;
    .order-platform {
      margin-top: 0.2rem;
      background-color: #fff;
      padding: 0 0.2rem 0.3rem;
      box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.22);
      .platform-title {
        position: relative;
        height: 0.93rem;
        display: flex;
        align-items: center;
        font-size: @fz28;
        color: @base;
        padding-left: 0.82rem;
        white-space: nowrap;
        em {
          font-weight: 700;
        }
        &::before {
          content: '';
          position: absolute;
          left: 0.23rem;
          width: 0.45rem;
          height: 0.35rem;
          background: url('../assets/img/cargo-van.png') center no-repeat;
          background-size: 100%;
        }
      }
      .fill-address {
        height: 0.8rem;
        padding: 0.3rem 0.32rem;
        button {
          width: 100%;
          height: 100%;
          border: 0.02rem solid #ff2851;
          color: #ff2851;
          font-size: @fz34;
          font-weight: 700;
          border-radius: 30px;
          animation: mymove 3s infinite;
        }
      }
      .platform-address {
        padding: 0.32rem 0.24rem 0;
      }
    }
    .platform-sku-list {
      padding-top: 0.2rem;
      height: 1.8rem;
      .flex-center;
      .jump-details {
        position: relative;
        padding: 0 0.2rem;
        height: 100%;
        background-color: #f2f2f2;
        display: flex;
        align-items: center;
        .sku-imgs {
          width: 5.6rem;
          overflow: hidden;
          .sku-imgs-wrapper {
            white-space: nowrap;
          }
        }
        .sku-img {
          position: relative;
          display: inline-block;
          width: 1.4rem;
          height: 1.4rem;
          margin-right: 0.24rem;
          background-color: #fff;
          &:last-child {
            margin-right: 0;
          }
          img {
            object-fit: contain;
          }
          .problem-mask {
            position: absolute;
            width: 60%;
            height: 60%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .flex-center;
            font-size: @fz22;
            color: #fff;
            background-color: rgba(0, 0, 0, 0.7);
            border-radius: 50%;
          }
        }
        .tips {
          font-size: @fz24;
          color: @base;
          padding-left: 0.2rem;
          white-space: nowrap;
          .flex-center;
          img {
            width: 0.3rem;
            height: 0.3rem;
          }
        }
      }
    }
    .platform-freight {
      margin-top: 0.17rem;
      font-size: @fz28;
      color: @base;
      text-align: right;
      em {
        color: @price;
      }
    }
  }
  .order-intro {
    background-color: #fff;
    .order-price {
      padding: 0 0.3rem;
      height: 0.84rem;
      .flex-between;
      font-size: 0.3rem;
      font-weight: bold;
      .title {
        color: @base;
      }
      .price {
        color: #ff3434;
      }
    }
    .order-options {
      padding: 0.17rem 0.3rem 0;
      color: #bababa;
      font-size: @fz24;
      .option {
        padding-bottom: 0.27rem;
        .flex-between;
        .title {
          display: flex;
          width: 1.4rem;
          justify-content: flex-end;
          align-items: center;
        }
      }
    }
    .arrow-right{
      background: url(../assets/img/arrow-right.png) no-repeat right top .08rem;
      background-size:.1rem .16rem;
      padding-right: .15rem;
    }
    .freight {
      .freight-tips {
        .flex-center;
      }
      .tips {
        display: inline-block;
        margin-left: 0.1rem;
        width: 0.32rem;
        height: 0.32rem;
        background: url('../assets/img/tips.png') center no-repeat;
        background-size: 100%;
      }
    }
  }
  .normal-price-c {
    color: #ff6060;
  }
  .discount-price-c {
    color: #2fbda1;
  }
  .discount-choose {
    font-size: @fz24;
    color: @base;
    background-color: #fff;
    margin-bottom: 0.35rem;
    .shopping-gold-wrapper {
      padding: 0.2rem 0.3rem;
      height: 0.95rem;
      .flex-between;
      .user-shopping-gold {
        height: 100%;
        .flex-column-between;

        span:nth-chil(1),
        span:nth-child(2) {
          color: @c80;
          font-size: @fz24;
        }
        .hint {
          font-size: @fz24;
          font-weight: bold;
        }
      }
      .shopping-gold-check-status {
        height: 100%;
        .flex-column-between;
        align-items: flex-end;
      }
    }
  }
  .open-member {
    position: relative;
    width: 6.9rem;
    height: 1.55rem;
    margin: 0.58rem auto 0;
    background: linear-gradient(
      180deg,
      rgba(30, 62, 117, 1) 0%,
      rgba(18, 33, 57, 1) 100%
    );
    border-radius: 0.1rem;
    font-size: @fz28;
    font-weight: 660;
    color: #fff;
    .flex-between;
    margin-bottom: 0.4rem;
    .member-intro {
      display: flex;
      flex-direction: column;
      p {
        padding-left: 0.32rem;
        em {
          color: #ff9600;
        }
      }
    }
    button {
      margin-right: 0.26rem;
      width: 1.96rem;
      height: 0.78rem;
      background-color: #f1c40f;
      border-radius: 30px;
      font-size: 0.32rem;
      color: #b53900;
    }
  }
  .shoping-trolley-footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #fff;
    height: 1.2rem;
    .flex-between;
    font-size: @fz28;
    .product-total-price {
      .flex-between;
      width: 100%;
      height: 100%;
      .total-price {
        padding-left: 0.36rem;
        .flex-center;
      }
      .total {
        color: @base;
        display: flex;
        white-space: nowrap;
        font-weight: 660;
        font-size: 0.34rem;
        span {
          padding-right: 0.2rem;
        }
        .price {
          color: #ff3737;
        }
      }
      .shop-wealfare {
        margin-left: 0.23rem;
        padding: 0.05rem 0.2rem;
        background-color: #ffe6e6;
        border-radius: 30px;
        font-size: @fz20;
        color: #e93b3b;
      }
    }
    .settle-accounts {
      width: 1.72rem;
      height: 100%;
      color: #fff;
      button {
        width: 100%;
        height: 100%;
        background-color: #ff3824;
        &:disabled {
          background-color: #333;
        }
      }
      .cannot-submit {
        background-color: #333;
      }
    }
  }
  .freight-tips-desc {
    padding-top: 0.45rem;
    h2 {
      font-size: @fz32;
      color: @base;
      font-weight: bold;
      padding-left: 0.38rem;
      border-left: 0.07rem solid #ff4141;
    }
    p {
      padding: 0.2rem 0.31rem 0.4rem;
    }
  }
}

.platform-goods {
  padding: 0 0.2rem;
  height: 100%;
  overflow: hidden;
  background-color: #fff;
  .title {
    padding: 0.3rem 0;
    font-size: 0.36rem;
    color: #404040;
    font-weight: bold;
  }
  .goods-list {
    height: 85%;
    .auto-y;
  }
  .goods-item {
    padding: 0.2rem 0;
  }
  .goods-details {
    display: flex;
    align-items: center;
    .goods-img {
      position: relative;
      width: 1.6rem;
      height: 1.6rem;
      .problem-mask {
        position: absolute;
        width: 60%;
        height: 60%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .flex-center;
        font-size: @fz26;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.7);
        border-radius: 50%;
      }
    }
    .goods-intro {
      margin-left: 0.2rem;
      width: 4.8rem;
      min-height: 1.6rem;
      color: #403232;
      .flex-column-between;
      .name {
        font-size: @fz24;
      }
      .sku-hint {
        font-size: @fz22;
        color: @member-text;
        i{
          color: #3cd407;
        }
        .red{
          color: #FF3824;
        }
      }
      .sub-name {
        font-size: @fz20;
        color: #b8b8b8;
        display: flex;
        span {
          padding: 0.02rem 0.08rem;
          border: 0.5px solid #cbcbcb;
          background-color: #f5f5f5;
          box-sizing: border-box;
          border-radius: 0.05rem;
        }
      }
      .goods-price-num {
        font-size: @fz24;
        .flex-between;
        .price {
          font-size: @fz20;
          color: @price;
          em {
            font-size: @fz28;
          }
        }
      }
      .goods-tips {
        font-size: @fz24;
        color: #ff3824;
      }
    }
  }
}
.dredge-tips {
  margin-top: 0.3rem;
}
</style>
